module.exports = __webpack_public_path__ + "img/eli-normal.4c5772e2.jpeg";